import { appendErrors } from 'react-hook-form'
import type { FieldError } from 'react-hook-form'
import type { z } from 'zod'

export type ErrorMap = Record<string, FieldError>

export function parseErrorSchema(
  zodErrors: z.ZodIssue[],
  validateAllFieldCriteria: boolean,
  initialMap: ErrorMap = {}
): ErrorMap {
  const errors = zodErrors.reduce<Record<string, FieldError>>((map, error) => {
    const { code, message, path: errorPath } = error
    const path = errorPath.join('.')

    if (!map[path]) {
      if ('unionErrors' in error) {
        const unionError = error.unionErrors[0]?.errors[0]

        if (unionError) {
          map[path] = {
            message: unionError.message,
            type: unionError.code,
          }
        }
      } else {
        map[path] = {
          message,
          type: code,
        }
      }
    }

    if ('unionErrors' in error) {
      parseErrorSchema(
        error.unionErrors.flatMap((e) => e.errors),
        validateAllFieldCriteria,
        map
      )
    }

    if (validateAllFieldCriteria) {
      const types = map[path]?.types
      const messages = types?.[code]

      map[path] = appendErrors(
        path,
        validateAllFieldCriteria,
        map,
        code,
        messages
          ? ([] as string[]).concat(messages as string[], message)
          : message
      ) as FieldError
    }

    return map
  }, initialMap)

  return errors
}
